
class PageLoader extends HTMLElement {
  static selectors = {
    links: 'button[data-loader],a[data-loader]:not([href="#"])'
  };

  constructor() {
    super();
    this.init();
  }

  init = () => {
    window.onpageshow = () => {
      this.close();
    };

    document.querySelectorAll(PageLoader.selectors.links).forEach((link) => {
      link.addEventListener('click', () => {
        this.open();
      });
    });
  }

  open = () => {
    this.classList.add('d-flex');
    this.classList.remove('d-none');
  }

  close = () => {
    this.classList.remove('d-flex');
    this.classList.add('d-none');
  }
}
if (!window.customElements.get("page-loader")) {
  window.customElements.define("page-loader", PageLoader);
}
if (!window.pageLoader) {
  window.pageLoader = document.querySelector('page-loader');
}